import React, { useEffect, useState } from 'react';

import * as env from 'config/environment';
import { isApp, isIosApp } from 'components/features/utils/userStatus';
import { getUserStorage } from 'components/features/utils/utils';
import LoginSideMenu from './components/LoginSideMenu';
import { HeadBlock } from './components/HeadBlock';
import Slider, { Settings } from 'react-slick';

export type NotificationItems = {
  ID: string;
  Type: number;
  Title: string;
  Content: string;
  InsTime: string;
  UpdTime: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const $: any;

const TargetLP: React.FC = () => {
  const [isShowSideMenu, setIsShowSideMenu] = useState(false);
  const [hideAnimate, setHideAnimate] = useState<boolean>(false);

  const menuShow = (): void => {
    setIsShowSideMenu(true);
    setHideAnimate(false);
  };
  const menuHide = (): void => {
    setIsShowSideMenu(false);
  };
  const menuHideAnimate = (): void => {
    setHideAnimate(true);
  };

  const userStorage = getUserStorage();
  const userType =
    userStorage === null
      ? 'guest'
      : userStorage.Charged
      ? 'premium'
      : 'not_premium';

  const isMinkabuMember = userStorage !== null ? true : false;

  const handlePremiumPage = env.helpPremiumURL;
  const linkSecuritiesAccountManagementLP = `${env.appURL}/securitiesAccountManagementLP`;

  const getURLWithParameter = (url: string): string => {
    return `${url}&service=${env.serviceName}&callback_url=${encodeURI(
      `${env.appURL}/auth`
    )}`;
  };
  const commonParam = `utm_source=tw_minkabu&utm_medium=lp_target&utm_campaign=asset_management202403`;

  const login = (): void => {
    window.location.href = `${getURLWithParameter(
      `${env.loginURL}?${commonParam}`
    )}`;
  };
  const register = (): void => {
    window.location.href = `${getURLWithParameter(
      `${env.registerURL}?${commonParam}`
    )}`;
  };

  const linkLogin = (positionNumber: number): string => {
    return `${env.loginURL}?${commonParam}_${positionNumber}&service=${
      env.serviceName
    }&callback_url=${encodeURI(`${env.appURL}/auth?callbackPath=/target`)}`;
  };
  const linkRegist = (num: number): string =>
    `${
      env.registerURL
    }?utm_source=tw_minkabu&utm_medium=lp_target&utm_campaign=asset_management202403_${num}&service=TradeWell&callback_url=${encodeURI(
      `${env.appURL}/auth`
    )}`;

  const linkTarget = (num: number): string =>
    isMinkabuMember ? linkLogin(num) : linkRegist(num);

  const linkPremium = `https://id.minkabu.jp/premium?utm_source=tw_minkabu&utm_medium=lp_target&utm_campaign=scroll_btn&service=${
    env.serviceName
  }&callback_url=${encodeURI(`${env.appURL}/auth`)}`;
  const linkNewRegist = isMinkabuMember
    ? linkPremium
    : `${
        env.registerURL
      }?utm_source=tw_minkabu&utm_medium=lp_target&utm_campaign=scroll_btn&service=TradeWell&callback_url=${encodeURI(
        `${env.appURL}/auth`
      )}`;

  useEffect(() => {
    //toggle(表示・非表示の切り替え)
    //.js_toggle_switchのデータ属性(data-toggle="クラス名")と同じクラス名の要素の表示非表示の切り替えを行う
    //
    //sample
    //<button class="js_toggle_switch" data-toggle="js_rnavi">ボタン</button>
    //<div class="js_rnavi">表示切り替えエリア</div>
    //
    //クラス名がかぶらないよう、操作するクラスにつけるクラス名はルール化する
    //クラス名ルール例："js_"+"表示する内容を詳しく"
    $(function() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      $('.js_toggle_switch').click(function(event: any) {
        const js_disp_area = '.' + $(event.currentTarget).data('toggle');
        $(js_disp_area).toggleClass('is-visible');
      });
    });

    //scroll
    const Ease = {
      easeInOut: (t: number) =>
        t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
    };
    const duration = 500;
    const smoothScrollTriggers = document.querySelectorAll('a[href^="#"]');
    smoothScrollTriggers.forEach(function(smoothScrollTrigger) {
      smoothScrollTrigger.addEventListener('click', function(e: Event) {
        const href = smoothScrollTrigger.getAttribute('href');
        const currentPostion =
          document.documentElement.scrollTop || document.body.scrollTop;
        const targetElement = document.getElementById(
          (href as string).replace('#', '')
        );
        if (targetElement) {
          e.preventDefault();
          e.stopPropagation();
          const targetPosition =
            window.pageYOffset +
            targetElement.getBoundingClientRect().top -
            115;
          const startTime = performance.now();
          const loop = function(nowTime: number) {
            const time = nowTime - startTime;
            const normalizedTime = time / duration;
            if (normalizedTime < 1) {
              window.scrollTo(
                0,
                currentPostion +
                  (targetPosition - currentPostion) *
                    Ease.easeInOut(normalizedTime)
              );
              requestAnimationFrame(loop);
            } else {
              window.scrollTo(0, targetPosition);
            }
          };
          requestAnimationFrame(loop);
        }
      });
    });

    //スクロールして画面内に入ってきたらfadeinアニメーションクラスを付与
    const myFunc = function() {
      //Classを追加する要素を取得
      const target = document.getElementsByClassName('js-ui-animation-fadeup');
      //Classを追加する位置を指定（ビューポート内）
      const position = Math.floor(window.innerHeight * 0.85); //左記はビューポート内の上から85%の位置を指定

      //要素の数だけループする
      for (let i = 0; i < target.length; i++) {
        //要素の上部座標を取得する（小数点切り捨て）
        const offsetTop = Math.floor(target[i].getBoundingClientRect().top); //要素の上部座標がpositionの位置を通過したら
        if (offsetTop < position) {
          //要素にClassを追加する
          target[i].classList.add('ui-animation-fadeup');
        }
      }
    };
    //スクロールイベントリスナーに登録
    window.addEventListener('scroll', myFunc, false);

    return () => {
      window.removeEventListener('scroll', myFunc, false);
    };
  }, []);

  const isIE =
    (window.navigator.userAgent ?? '').toLowerCase().indexOf('trident') !== -1;

  const headBlockValue = {
    title:
      'AIポートフォリオ管理で投資をサポート｜アセプラ（みんかぶアセットプランナー）',
    ogTitle:
      'AIポートフォリオ管理で投資をサポート｜アセプラ（みんかぶアセットプランナー）',
    description:
      'ポートフォリオ管理をAIがアドバイス！ライフイベントごとに必要な資産形成・低リスク運用をAIがサポート。「目的別」投資シミュレーションで将来の資産も見える化。わかりやすい画面は初心者にもおすすめです。「資産・株式管理」ならみんかぶアセットプランナー',
    ogDescription:
      'ポートフォリオ管理をAIがアドバイス！ライフイベントごとに必要な資産形成・低リスク運用をAIがサポート。「目的別」投資シミュレーションで将来の資産も見える化。わかりやすい画面は初心者にもおすすめです。「資産・株式管理」ならみんかぶアセットプランナー',
    img: 'https://tw.minkabu.jp/static/images/targetLP/target_og_image.png',
    canonical: 'https://tw.minkabu.jp/targetLP',
    firstScript: `{
      "@context": "https://schema.org/",
      "@type": "WebPage",
      "name": "アセプラ(みんかぶアセットプランナー)",
      "image": [
        "https://tw.minkabu.jp/static/images/lp/mainimage.jpg",
        "https://tw.minkabu.jp/static/images/lp/home_shisan.png",
        "https://tw.minkabu.jp/static/images/lp/aruaru_rikaku.png",
        "https://tw.minkabu.jp/static/images/lp/oshirase.png",
        "https://tw.minkabu.jp/static/images/lp/aruaru_songiri.png"
       ],
      "description": "ポートフォリオ管理をAIがアドバイス！ライフイベントごとに必要な資産形成・低リスク運用をAIがサポート。「目的別」投資シミュレーションで将来の資産も見える化。わかりやすい画面は初心者にもおすすめです。「資産・株式管理」ならみんかぶアセットプランナー",
      "brand": {
        "@type": "Brand",
        "name": "みんかぶ"
      }
    }`,
    secondScript: `{
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "みんかぶアセットプランナー（アセプラ）とは何ですか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "みんかぶアセットプランナーとは、株式や投資信託を管理、分析する投資管理アプリです。ポートフォリオを管理・分析し「老後資金2,000万円」などライフプランに沿った資産形成をサポートします。"
          }
        },
        {
          "@type": "Question",
          "name": "みんかぶアセットプランナー（アセプラ）でどんなことができますか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "「老後資金2,000万円」などお金を貯める目的と目標金額から資産形成をシミュレーションし、目標達成に必要な利回り、目標ポートフォリオ、低リスクの投資商品の提案を受けることができます。"
          }
        },
        {
          "@type": "Question",
          "name": "連携できる証券会社はどこですか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "SBI証券、楽天証券をご連携いただけます。その他の証券会社は連携準備中となります（2025年8月時点）。<br>連携準備中の証券会社はMoneytreeと連携することで一部の資産を管理できます。"
          }
        },
        {
          "@type": "Question",
          "name": "連携できる金融商品はなんですか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "国内株式（現物、信用）、外国株式（現物）、投資信託、ETF・ETN（国内、外国）、REIT（国内、外国）、債券（国内、外国）、EB（国内、外国）、ロボアドバイザー、現金を連携できます。不動産、ゴールドなどは、手入力で管理できます。"
          }
        },
        {
          "@type": "Question",
          "name": "銀行口座も連携できますか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "みんかぶアセットプランナーでは家計簿アプリ「マネーツリー」と連携し、銀行口座の「残高」や「取引/入出金履歴」を管理することができます。※ Moneytree IDと連携する必要があります。詳しくは「銀行口座を連携したい」にお答えしますをご参照下さい。"
          }
        },
        {
          "@type": "Question",
          "name": "おすすめの国内株式を提案する機能はありますか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "みんかぶアセットプランナーには国内株式を提案する機能はありません。みんかぶの「株式ランキング」や「銘柄スクリーニング」などで銘柄を探すことができます。"
          }
        },
        {
          "@type": "Question",
          "name": "みんかぶアセットプランナーの利用料金を教えてください",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "全ての機能を利用するには「みんかぶプレミアム（税込1,320円/月）」にご登録が必要です。<br>初回登録のみ30日間無料でご利用いただけます。"
          }
        }
      ]
    }`,
  };

  /* eslint-disable react/jsx-no-target-blank */
  return (
    <>
      <HeadBlock
        {...{
          title: headBlockValue.title,
          ogTitle: headBlockValue.ogTitle,
          description: headBlockValue.description,
          ogDescription: headBlockValue.ogDescription,
          img: headBlockValue.img,
          canonical: headBlockValue.canonical,
          firstScript: headBlockValue.firstScript,
          secondScript: headBlockValue.secondScript,
        }}
      />
      <div
        className={['login relative', isShowSideMenu && 'md_drawerright_open']
          .filter(x => x)
          .join(' ')}
        id="layout">
        <header className="bg-white z-50 shadow-md sticky top-0" id="id_header">
          <nav className="container space-x-2 items-center ui-header lg:flex hidden">
            <div className="text-gray-700 text-center ui-header-logo">
              <a title="みんかぶ" href={`https://minkabu.jp/?${commonParam}`}>
                <img
                  src="https://assets.minkabu.jp/images/logo/v4/logo_minkabu.svg"
                  width="146"
                  height="40"
                  alt="みんかぶ"
                />
              </a>
            </div>
            <div className="ui-header-menu">
              <ul className="flex justify-start pl-7 relative">
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href={`https://minkabu.jp/?${commonParam}`}>
                    株式
                  </a>
                </li>
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href={`https://us.minkabu.jp/?${commonParam}`}>
                    米国株
                  </a>
                </li>
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href={`https://fx.minkabu.jp/?${commonParam}`}>
                    FX/為替
                  </a>
                </li>
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href={`https://cc.minkabu.jp/?${commonParam}`}>
                    仮想通貨
                  </a>
                </li>
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href={`https://itf.minkabu.jp/?${commonParam}`}>
                    投信
                  </a>
                </li>
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href={`https://fu.minkabu.jp/?${commonParam}`}>
                    先物
                  </a>
                </li>
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href={`https://ins.minkabu.jp/?${commonParam}`}>
                    保険
                  </a>
                </li>
                <li>
                  <a
                    className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                    href={`https://mag.minkabu.jp/?${commonParam}`}>
                    初心者
                  </a>
                </li>
              </ul>
            </div>
            <div className="ui-header-button-wrapper flex justify-end">
              <div className="ui-header-button flex space-x-2 lg:text-sm text-xs">
                {isIE && (
                  <div className="text-sm text-gray-700">
                    Internet Explorerブラウザではご利用いただけません
                  </div>
                )}
                {!isIE && (
                  <>
                    <button
                      className="ui-button theme-normal w-1/2 login-exe"
                      id="click_target_header_login"
                      onClick={login}>
                      ログイン
                    </button>
                    <button
                      className="ui-button theme-sub w-1/2 register-exe"
                      id="click_target_header_register"
                      onClick={register}>
                      新規登録
                    </button>
                  </>
                )}
              </div>
            </div>
          </nav>
          <div className="ui-header-sp border-b border-gray-300 block lg:hidden">
            <nav className="flex p-2">
              <div className="flex-1 flex justify-start">
                <button className="flex items-center p-2 hidden">
                  <i className="icon-chevron-left text-2xl text-gray-700"></i>
                </button>
              </div>
              <div className="flex-grow flex justify-center items-center">
                <a title="みんかぶ" href={`https://minkabu.jp/?${commonParam}`}>
                  <img
                    src="https://assets.minkabu.jp/images/logo/v4/logo_minkabu.svg"
                    width="110"
                    height="30"
                    alt="みんかぶ"
                  />
                </a>
              </div>
              <div className="flex-1 flex justify-end">
                <section className="pl-4 pr-2 pt-2 ">
                  {!isApp && (
                    <div
                      className="btn-trigger "
                      id="btn01"
                      onClick={!isShowSideMenu ? menuShow : menuHideAnimate}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  )}
                </section>
              </div>
            </nav>
          </div>
          <div className="w-full lg:block hidden bg-gray-800">
            <nav className="relative  shadow top-0 border-t-0 text-white container m-auto">
              <ul className="table table-fixed font-bold w-full">
                <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                  <a
                    style={{ lineHeight: '50px' }}
                    className="inline-block w-full"
                    href="https://minkabu.jp/pick/balance/buy"
                    title="株価予想">
                    株価予想
                  </a>
                </li>
                <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                  <a
                    style={{ lineHeight: '50px' }}
                    className="inline-block w-full"
                    href="https://minkabu.jp/financial_item_ranking"
                    title="株式ランキング">
                    株式ランキング
                  </a>
                </li>
                <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                  <a
                    style={{ lineHeight: '50px' }}
                    className="inline-block w-full"
                    href="https://minkabu.jp/news"
                    title="ニュース">
                    ニュース
                  </a>
                </li>
                <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                  <a
                    style={{ lineHeight: '50px' }}
                    className="inline-block w-full"
                    href="https://minkabu.jp/ir"
                    title="IRwith">
                    IRwith
                  </a>
                </li>
                <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                  <a
                    style={{ lineHeight: '50px' }}
                    className="inline-block w-full"
                    href="https://minkabu.jp/beginner/"
                    title="株初心者入門">
                    株初心者入門
                  </a>
                </li>
                <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25 relative">
                  <a
                    style={{ lineHeight: '50px' }}
                    className="inline-block w-full"
                    href="https://tw.minkabu.jp/"
                    title="アセプラ（みんかぶアセットプランナー）へ">
                    アセプラで資産形成
                  </a>
                  <div className="h-1 bg-red-500 w-full absolute bottom-0"></div>
                </li>
              </ul>
            </nav>
          </div>
        </header>

        {isShowSideMenu && (
          <LoginSideMenu
            hideAnimate={hideAnimate}
            menuHide={menuHide}
            onNavLinkClick={(e: React.MouseEvent, path: string) => {
              return;
            }}
          />
        )}

        {/* PC */}
        <div id="top"></div>
        <div className="hidden lg:flex main-back w-full h-104 bg-cyan-600 relative">
          <div className="w-full z-10">
            <div
              className="flex w-full h-104 mx-auto relative"
              style={{ maxWidth: '1080px' }}>
              <h1 className="w-2/3 relative">
                <img
                  src="/static/images/targetLP/main1.svg"
                  alt="投資目標のアドバイス"
                  className="absolute block z-10"
                  style={{ top: '21%', left: '-3%' }}
                />
                <img
                  src="/static/images/targetLP/main2.svg"
                  alt="あなたのポートフォリオを分析 AIアドバイスで投資の目標を達成しよう！"
                  className="absolute block"
                  style={{ top: '13%', left: '29%' }}
                />
                <img
                  src="/static/images/targetLP/main3.svg"
                  alt="貯金 投資"
                  className="absolute block z-10"
                  style={{ top: '28%', left: '93%' }}
                />
              </h1>
            </div>
          </div>
        </div>
        {/* SP */}
        <div className="lg:hidden bg-cyan-600 z-10">
          <div
            className="w-full h-full pt-8 mx-auto relative"
            style={{ maxWidth: '1080px' }}>
            <h1 className="relative overflow-hidden bg-cyan-600">
              <img
                src="/static/images/lp/main_back_sp.png"
                alt=""
                width="1560"
                height="1000"
                className="block"
              />
              <img
                src="/static/images/targetLP/main2.svg"
                alt="あなたのポートフォリオを分析 AIアドバイスで投資の目標を達成しよう！"
                className="w-full absolute z-10"
                style={{ top: '0%', left: '0%' }}
              />
              <img
                src="/static/images/targetLP/main3.svg"
                alt="貯金 投資"
                className="absolute"
                style={{
                  width: '76%',
                  top: '27%',
                  left: '-20%',
                }}
              />
              <img
                src="/static/images/targetLP/main1.svg"
                alt="投資目標のアドバイス"
                className="absolute"
                style={{
                  width: '57%',
                  top: '44.6%',
                  left: '50%',
                  transform: 'scale(-1, 1)',
                }}
              />
            </h1>
          </div>
        </div>

        {!isApp && (
          <>
            {/* 銀行だけでは資産は増えません! */}
            <section className="bg-cyan-650 text-white">
              {/* PC */}
              <div className="hidden lg:flex flex-col container w-full pb-16">
                <h2 className="pt-16 text-40 font-bold text-center">
                  銀行だけでは資産は増えません！
                </h2>
                <div>
                  <div className="flex justify-center mt-6 mb-2">
                    <img
                      src="/static/images/targetLP/person4.svg"
                      alt="Aさんのケース　30歳"
                      className="w-full"
                      style={{ width: '450px', height: '130px' }}
                    />
                  </div>
                  <div className="flex items-center justify-center">
                    <div className="text-2xl font-bold leading-8">
                      <div>年　収：５００万円</div>
                      <div>貯　金：３００万円</div>
                      <div>子ども：１人</div>
                    </div>
                  </div>
                  <div
                    className="mt-6 text-center text-34 font-bold"
                    style={{ lineHeight: '2.125rem' }}>
                    300万円を年利５%で25年運用すると
                    <br />
                    預貯金の約
                    <span className="text-yellow-450">
                      <span style={{ fontSize: '57px', lineHeight: '3.5rem' }}>
                        3.3
                      </span>
                      倍
                    </span>
                    以上
                  </div>
                  <div className="flex justify-center mt-4">
                    <img
                      src="/static/images/targetLP/chart1.svg"
                      alt="年利で資産運用をした場合のチャート図"
                      className="ml-8"
                      style={{ width: '760px', height: '400px' }}
                    />
                  </div>
                  <div className="flex flex-col items-center mt-4 text-lg">
                    <div>
                      ※ 複利計算（元本合計）シミュレーションを使用しています
                      <br />※ 預貯金の金利は0.002%で計算しています
                    </div>
                  </div>
                  <div className="relative mt-16">
                    <div
                      className="absolute"
                      style={{ top: '-20%', left: '21%' }}>
                      <img
                        src="/static/images/targetLP/light.svg"
                        alt="将来の資産形成におすすめな情報"
                      />
                    </div>
                    <div
                      className="mt-8 py-12 mx-52 text-center text-3xl font-bold border-2 border-white rounded-3xl"
                      style={{ lineHeight: '2.75rem' }}>
                      将来のお金の不安は
                      <br />
                      <span
                        style={{
                          fontSize: '37px',
                          lineHeight: '3.5rem',
                          backgroundImage:
                            'linear-gradient(to bottom, transparent 60%, rgb(255, 186, 7) 60%, rgb(255, 186, 7) 80%, transparent 80%)',
                        }}>
                        預貯金と投資を組み合わせて
                      </span>
                      <br />
                      解決するのがオススメです！
                    </div>
                  </div>
                </div>
              </div>
              {/* SP */}
              <div className="flex lg:hidden flex-col container w-full px-4 pb-16">
                <h2
                  className="pt-12 text-2xl font-bold text-center"
                  style={{ lineHeight: '1.875rem' }}>
                  銀行だけでは資産は
                  <br />
                  増えません！
                </h2>
                <div>
                  <div className="flex justify-center my-2 mb-4">
                    <img
                      src="/static/images/targetLP/person4.svg"
                      alt="Aさんのケース　30歳"
                      className="w-full px-16"
                    />
                  </div>
                  <div className="flex flex-col items-center text-lg font-bold">
                    <div>
                      年　収：５００万円
                      <br />
                      貯　金：３００万円
                      <br />
                      子ども：１人
                    </div>
                  </div>
                  <div
                    className="mt-2 text-center text-3xl font-bold"
                    style={{ lineHeight: '3.375rem' }}>
                    <span
                      className="text-lg"
                      style={{ lineHeight: '1.125rem' }}>
                      300万円を年利５%で25年運用すると
                    </span>
                    <br />
                    預貯金の約
                    <span className="text-yellow-450">
                      <span
                        style={{ fontSize: '54px', lineHeight: '1.875rem' }}>
                        3.3
                      </span>
                      倍
                    </span>
                    以上
                  </div>
                  <div className="flex justify-center mt-4">
                    <img
                      src="/static/images/targetLP/chart1.svg"
                      alt="年利で資産運用をした場合のチャート図"
                      className="w-full"
                    />
                  </div>
                  <div className="flex flex-col mt-4 text-xs">
                    <div>
                      ※ 複利計算（元本合計）シミュレーションを使用しています
                      <br />※ 預貯金の金利は0.002%で計算しています
                    </div>
                  </div>
                  <div className="relative mt-12">
                    <div
                      className="absolute"
                      style={{ top: '-18%', left: '5%' }}>
                      <img
                        src="/static/images/targetLP/light.svg"
                        alt="将来の資産形成におすすめな情報"
                        style={{ width: '70px', height: '70px' }}
                      />
                    </div>
                    <div
                      className="mt-8 py-6 text-center text-lg font-bold border-2 border-white rounded-2xl"
                      style={{ lineHeight: '1.625rem' }}>
                      将来のお金の不安は
                      <br />
                      <span
                        className="text-22"
                        style={{
                          backgroundImage:
                            'linear-gradient(to bottom, transparent 60%, rgb(255, 186, 7) 60%, rgb(255, 186, 7) 80%, transparent 80%)',
                        }}>
                        預貯金と投資を組み合わせて
                      </span>
                      <br />
                      解決するのがオススメです！
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* リスクを理解して自分にあう投資をすることが大切です */}
            <section className="js-ui-animation-fadeup">
              {/* PC */}
              <div className="hidden lg:flex flex-col container mt-16">
                <div className="text-center mb-8">
                  <h2 className="text-3.5xl font-bold mb-2 leading-12">
                    リスクを理解して自分にあう
                    <br />
                    投資をすることが大切です
                  </h2>
                  <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2"></div>
                </div>
                <div className="text-lg text-center leading-8">
                  資産運用とは、自分が持っている資産を預貯金や投資で効率的に増やしていくことです。
                  <br />
                  資産運用には、株式、投資信託、債券などがあります。
                </div>
                <div className="flex justify-center mt-8">
                  <img
                    src="/static/images/targetLP/chart2.svg"
                    alt="投資別リスク度の図"
                    style={{ width: '760px', height: '400px' }}
                  />
                </div>
                <div className="mt-8 text-lg text-center leading-8">
                  資産運用のほとんどは、元本保証がありません。
                  <br />
                  リスクを理解しながら自分なりの投資スタンスを持つことが大切です。
                </div>
                <div
                  className="flex flex-row justify-center px-20 mt-8"
                  style={{ height: '380px' }}>
                  <div
                    className="flex flex-col items-center py-6 px-4 text-white bg-cyan-650 rounded-lg"
                    style={{ width: '380px' }}>
                    <div className="text-xl font-bold leading-8">
                      投資のメリット
                    </div>
                    <div className="mt-4">
                      <img
                        src="/static/images/targetLP/understand_risk1.svg"
                        alt="投資のメリットについて"
                      />
                    </div>
                    <div className="mt-5">
                      <div className="flex flex-row items-center">
                        <div>
                          <img
                            src="/static/images/targetLP/check1.svg"
                            alt=""
                          />
                        </div>
                        <div className="ml-2 text-base">
                          預貯金より資産を増やせる
                        </div>
                      </div>
                      <div className="flex flex-row items-center mt-2">
                        <div>
                          <img
                            src="/static/images/targetLP/check1.svg"
                            alt=""
                          />
                        </div>
                        <div className="ml-2 text-base">
                          労働収入以外でお金を増やせる
                        </div>
                      </div>
                      <div className="flex flex-row items-center mt-2">
                        <div>
                          <img
                            src="/static/images/targetLP/check1.svg"
                            alt=""
                          />
                        </div>
                        <div className="ml-2 text-base">
                          将来のお金の不安がなくなる
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="flex flex-col items-center ml-8 py-6 px-4 text-white bg-gray-800 rounded-lg"
                    style={{ width: '380px' }}>
                    <div className="text-xl font-bold leading-8">
                      投資のデメリット
                    </div>
                    <div className="mt-4">
                      <img
                        src="/static/images/targetLP/understand_risk2.svg"
                        alt="投資のデメリットについて"
                      />
                    </div>
                    <div className="mt-5">
                      <div className="flex flex-row items-center">
                        <div>
                          <img
                            src="/static/images/targetLP/check2.svg"
                            alt=""
                          />
                        </div>
                        <div className="ml-2 text-base">
                          元本割れで損をすることがある
                        </div>
                      </div>
                      <div className="flex flex-row items-center mt-2">
                        <div>
                          <img
                            src="/static/images/targetLP/check2.svg"
                            alt=""
                          />
                        </div>
                        <div className="ml-2 text-base">
                          運用方法や銘柄の選び方が難しい
                        </div>
                      </div>
                      <div className="flex flex-row items-center mt-2">
                        <div>
                          <img
                            src="/static/images/targetLP/check2.svg"
                            alt=""
                          />
                        </div>
                        <div className="ml-2 text-base">専門的な知識が必要</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex justify-center mt-8">
                  <img
                    src="/static/images/targetLP/understand_risk3.svg"
                    alt="投資のお悩み"
                    className="w-full"
                    style={{ width: '550px', height: '300px' }}
                  />
                </div>
              </div>
              {/* SP */}
              <div
                className="flex lg:hidden flex-col container w-full px-4 bg-neutral-150"
                style={{ paddingTop: '14%' }}>
                <div className="text-center pb-8">
                  <h2 className="text-2xl font-bold mb-2 leading-8">
                    リスクを理解して自分にあう
                    <br />
                    投資をすることが大切です
                  </h2>
                  <div className="h-4 w-64 bg-red-500 right-half mx-auto"></div>
                </div>
                <div className="text-sm">
                  資産運用とは、自分が持っている資産を預貯金や投資で効率的に増やしていくことです。資産運用には、株式、投資信託、債券などがあります。
                </div>
                <div className="flex justify-center mt-10">
                  <img
                    src="/static/images/targetLP/chart2.svg"
                    alt="投資別リスク度の図"
                    className="w-full px-2"
                  />
                </div>
                <div className="mt-8 text-sm text-center">
                  資産運用のほとんどは、元本保証がありません。
                  <br />
                  リスクを理解しながら自分なりの
                  <br />
                  投資スタンスを持つことが大切です。
                </div>
                <div className="flex flex-col mt-8">
                  <div className="w-full h-full min-h-92 flex flex-col items-center px-4 py-6 text-white bg-cyan-650 rounded-lg">
                    <div className="text-xl font-bold">投資のメリット</div>
                    <div className="mt-4">
                      <img
                        src="/static/images/targetLP/understand_risk1.svg"
                        alt="投資のメリットについて"
                      />
                    </div>
                    <div className="mt-5">
                      <div className="flex flex-row items-center">
                        <div>
                          <img
                            src="/static/images/targetLP/check1.svg"
                            alt=""
                          />
                        </div>
                        <div className="ml-2 text-base">
                          預貯金より資産を増やせる
                        </div>
                      </div>
                      <div className="flex flex-row items-center mt-2">
                        <div>
                          <img
                            src="/static/images/targetLP/check1.svg"
                            alt=""
                          />
                        </div>
                        <div className="ml-2 text-base">
                          労働収入以外でお金を増やせる
                        </div>
                      </div>
                      <div className="flex flex-row items-center mt-2">
                        <div>
                          <img
                            src="/static/images/targetLP/check1.svg"
                            alt=""
                          />
                        </div>
                        <div className="ml-2 text-base">
                          将来のお金の不安がなくなる
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-full h-full min-h-92 flex flex-col items-center px-4 py-6 mt-4 text-white bg-gray-800 rounded-lg">
                    <div className="text-xl font-bold">投資のデメリット</div>
                    <div className="mt-4">
                      <img
                        src="/static/images/targetLP/understand_risk2.svg"
                        alt="投資のデメリットについて"
                      />
                    </div>
                    <div className="mt-5">
                      <div className="flex flex-row items-center">
                        <div>
                          <img
                            src="/static/images/targetLP/check2.svg"
                            alt=""
                          />
                        </div>
                        <div className="ml-2 text-base">
                          元本割れで損をすることがある
                        </div>
                      </div>
                      <div className="flex flex-row items-center mt-2">
                        <div>
                          <img
                            src="/static/images/targetLP/check2.svg"
                            alt=""
                          />
                        </div>
                        <div className="ml-2 text-base">
                          運用方法や銘柄の選び方が難しい
                        </div>
                      </div>
                      <div className="flex flex-row items-center mt-2">
                        <div>
                          <img
                            src="/static/images/targetLP/check2.svg"
                            alt=""
                          />
                        </div>
                        <div className="ml-2 text-base">専門的な知識が必要</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex justify-center mt-6">
                  <img
                    src="/static/images/targetLP/understand_risk3.svg"
                    alt="投資のお悩み"
                    className="w-full px-2"
                  />
                </div>
              </div>
            </section>
            {/* アセプラなら、リスクに備えた資産形成ができます！ */}
            <section className="bg-cyan-650 text-white">
              {/* PC */}
              <div className="hidden lg:flex flex-col container w-full pb-16">
                <div className="relative pt-16">
                  <div className="absolute" style={{ top: '9%', left: '26%' }}>
                    <img
                      src="/static/images/targetLP/arrow_box.svg"
                      alt="不安を解決"
                      style={{ width: '125px', height: '132px' }}
                    />
                  </div>
                  <div className="text-xl text-center underline">
                    少ないリスクで
                    <br />
                    投資にチャレンジしたい方へ
                  </div>
                  <h2 className="mt-4 text-3.5xl font-bold text-center">
                    アセプラなら、リスクに備えた
                    <br />
                    資産形成ができます！
                  </h2>
                </div>
                <div className="flex flex-col items-center mt-16">
                  <div className="flex flex-row items-center relative">
                    <img
                      src="/static/images/targetLP/person1.svg"
                      alt="投資レビューや感想"
                      style={{ width: '100px', height: '100px' }}
                    />
                    <h3
                      className="ml-6 py-2.5 px-6 text-2xl font-bold text-bluegray-700 bg-white rounded-lg shadow-lg"
                      style={{ width: '540px' }}>
                      つみたて額や運用期間から「目標達成に
                      <br />
                      必要な利回り」を自動計算するからラク！
                    </h3>
                    <div
                      className="bg-white w-6 h-6 absolute"
                      style={{
                        transform: 'rotate(45deg)',
                        top: '28%',
                        left: '17%',
                        zIndex: 0,
                      }}></div>
                  </div>
                </div>
                <div className="flex flex-col items-center mt-16">
                  <div className="flex flex-row items-center relative">
                    <h3
                      className="mr-6 py-2.5 px-6 text-2xl font-bold text-bluegray-700 bg-white rounded-lg shadow-lg"
                      style={{ width: '540px' }}>
                      「目標ポートフォリオ」と比べて、どの投資
                      <br />
                      商品に資産を分散すればいいかがわかる！
                    </h3>
                    <img
                      src="/static/images/targetLP/person2.svg"
                      alt="分散投資についてのコメント"
                      style={{ width: '100px', height: '100px' }}
                    />
                    <div
                      className="bg-white w-6 h-6 absolute"
                      style={{
                        transform: 'rotate(45deg)',
                        top: '28%',
                        left: '79%',
                        zIndex: 0,
                      }}></div>
                  </div>
                </div>
                <div className="flex flex-col items-center mt-16">
                  <div className="flex flex-row items-center relative">
                    <img
                      src="/static/images/targetLP/person3.svg"
                      alt="低リスクの投資商品のコメント"
                      style={{ width: '100px', height: '100px' }}
                    />
                    <h3
                      className="ml-6 py-2.5 px-6 text-2xl font-bold text-bluegray-700 bg-white rounded-lg shadow-lg"
                      style={{ width: '540px' }}>
                      「低リスクの投資商品」はAIがサポート！
                      <br />
                      リスト形式でかんたんに見つかる◎
                    </h3>
                    <div
                      className="bg-white w-6 h-6 absolute"
                      style={{
                        transform: 'rotate(45deg)',
                        top: '28%',
                        left: '17%',
                        zIndex: 0,
                      }}></div>
                  </div>
                </div>
                <div className="flex flex-col items-center mt-6">
                  <div className="flex bg-gradient-to-r bg-gradient-r-red flex-col text-center text-xl w-full max-w-btn-l py-4 text-white leading-9 rounded-lg mt-12 mb-4 cursor-pointer hover:opacity-75">
                    <a href={linkTarget(1)} id="click_target_try_target_1_pc">
                      {isMinkabuMember ? (
                        <div className="font-bold">資産目標サポートを試す</div>
                      ) : (
                        <>
                          <div className="flex justify-center mb-auto app-primary-label-block text-19">
                            <div className="inline-flex items-center flex-col">
                              初回30日間無料
                            </div>
                          </div>
                          <div className="font-bold">
                            みんかぶプレミアムで資産目標サポートを試す
                          </div>
                        </>
                      )}
                    </a>
                  </div>
                  <div className="leading-9 text-base flex justify-center items-center cursor-pointer underline">
                    <a
                      href={`${handlePremiumPage}?${commonParam}`}
                      target="_blank"
                      rel="noopener">
                      みんかぶプレミアムとは
                    </a>
                  </div>
                  {!isMinkabuMember && (
                    <div
                      className="mt-4 leading-9 text-base flex justify-center items-center cursor-pointer underline"
                      onClick={login}>
                      すでにみんかぶ会員の方はこちら
                    </div>
                  )}
                </div>
              </div>
              {/* SP */}
              <div className="flex lg:hidden flex-col container w-full px-4 pb-16">
                <div className="w-full flex flex-col items-center justify-center mt-16">
                  <div className="text-center text-base underline">
                    少ないリスクで
                    <br />
                    投資にチャレンジしたい方へ
                  </div>
                  <div className="relative pl-5">
                    <div
                      className="absolute"
                      style={{ top: '-55px', left: '-40px', zIndex: 0 }}>
                      <img
                        src="/static/images/targetLP/arrow_box.svg"
                        alt="不安を解決"
                        style={{ width: '80px', height: '87px' }}
                      />
                    </div>
                    <h2 className="mt-4 text-xl font-bold text-center">
                      アセプラなら、リスクに備えた
                      <br />
                      資産形成ができます！
                    </h2>
                  </div>
                </div>

                <div className="w-full flex flex-row items-start justify-center mt-4">
                  <img
                    src="/static/images/targetLP/person1.svg"
                    alt="投資レビューや感想"
                    style={{ width: '58px', height: '58px' }}
                  />
                  <div className="relative pl-5">
                    <div
                      className="bg-white w-5 h-5 absolute"
                      style={{
                        transform: 'rotate(45deg)',
                        top: '17px',
                        left: '10px',
                        zIndex: 0,
                      }}></div>
                    <h3 className="p-4 text-base font-bold text-bluegray-700 bg-white rounded-lg shadow-lg">
                      つみたて額や運用期間から「目標達成に必要な利回り」を自動計算するからラク！
                    </h3>
                  </div>
                </div>
                <div className="w-full flex flex-row items-start justify-center mt-10">
                  <div className="relative pr-5">
                    <h3 className="p-4 text-base font-bold text-bluegray-700 bg-white rounded-lg shadow-lg">
                      「目標ポートフォリオ」と比べて、どの投資商品に資産を分散すればいいかがわかる！
                    </h3>
                    <div
                      className="bg-white w-5 h-5 absolute"
                      style={{
                        transform: 'rotate(45deg)',
                        top: '18px',
                        right: '10px',
                        zIndex: 0,
                      }}></div>
                  </div>
                  <img
                    src="/static/images/targetLP/person2.svg"
                    alt="分散投資についてのコメント"
                    style={{ width: '58px', height: '58px' }}
                  />
                </div>
                <div className="w-full flex flex-row items-start justify-center mt-10">
                  <img
                    src="/static/images/targetLP/person3.svg"
                    alt="低リスクの投資商品のコメント"
                    style={{ width: '58px', height: '58px' }}
                  />
                  <div className="relative pl-5">
                    <div
                      className="bg-white w-5 h-5 absolute"
                      style={{
                        transform: 'rotate(45deg)',
                        top: '17px',
                        left: '10px',
                        zIndex: 0,
                      }}></div>
                    <h3 className="p-4 text-base font-bold text-bluegray-700 bg-white rounded-lg shadow-lg">
                      「低リスクの投資商品」はAIがサポート！リスト形式でかんたんに見つかる◎
                    </h3>
                  </div>
                </div>
                <div className="flex flex-col items-center mx-4">
                  <div className="bg-gradient-to-r bg-gradient-r-red flex flex-col text-center text-lg w-full max-w-btn-l py-2 mx-auto text-white rounded-lg my-8 cursor-pointer hover:opacity-75">
                    <a href={linkTarget(1)} id="click_target_try_target_1_sp">
                      {isMinkabuMember ? (
                        <div className="font-bold">資産目標サポートを試す</div>
                      ) : (
                        <>
                          <div className="flex justify-center mb-auto app-primary-label-block text-sm">
                            <div className="inline-flex justify-center flex-col">
                              初回30日間無料
                            </div>
                          </div>
                          <div className="font-bold leading-6">
                            みんかぶプレミアムで
                            <br />
                            資産目標サポートを試す
                          </div>
                        </>
                      )}
                    </a>
                  </div>
                  <div className="leading-9 text-base flex justify-center items-center cursor-pointer underline">
                    <a
                      href={`${handlePremiumPage}?${commonParam}`}
                      target="_blank"
                      rel="noopener">
                      みんかぶプレミアムとは
                    </a>
                  </div>
                  {!isMinkabuMember && (
                    <div
                      className="mt-4 leading-9 text-base flex justify-center items-center cursor-pointer underline"
                      onClick={login}>
                      すでにみんかぶ会員の方はこちら
                    </div>
                  )}
                </div>
              </div>
            </section>
            {/* ライフイベントごとに必要なお金をAIアドバイスで貯められる */}
            <section className="text-white bg-gray-800">
              {/* PC */}
              <div className="hidden lg:flex flex-col text-center container pt-16 pb-16">
                <h2 className="text-3.5xl font-bold mb-2 leading-12">
                  ライフイベントごとに必要なお金を
                  <br />
                  AIアドバイスで貯められる
                </h2>
                <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2"></div>
                <div
                  className="mt-8 text-lg"
                  style={{ lineHeight: '1.625rem' }}>
                  資産目標サポートでは、お金を貯める目的と目標金額から、
                  <br />
                  あなたにあった資産運用の達成をAIがアドバイスします。
                  <br />
                  「老後資金を貯めたい」「FIRE資金が欲しい」「教育費を準備したい」など
                  <br />
                  ライフイベントごとに必要なお金がきちんと貯められてるかがわかります！
                </div>
                <div className="flex items-end justify-center mt-8 mb-auto text-3xl leading-8">
                  <img src="/static/images/targetLP/line1.svg" alt="" />
                  <div className="inline-flex items-end flex-row mx-4 font-bold">
                    <h3 className="block">アセプラでできること</h3>
                  </div>
                  <img
                    src="/static/images/targetLP/line1.svg"
                    alt=""
                    style={{
                      transform: 'scale(-1, 1)',
                    }}
                  />
                </div>
                <SliderArea />
                <div className="flex justify-center mt-8">
                  <img
                    src="/static/images/targetLP/report_notification.png"
                    alt="資産を管理、LINEに日々の資産情報を通知します"
                    style={{ width: '465px', height: '405px' }}
                  />
                </div>
                <div className="mt-4 text-2xl font-bold text-center">
                  資産レポートで
                  <br />
                  運用状況をチェック！LINEも対応！
                </div>
                <div className="flex flex-col items-center">
                  <div className="flex bg-gradient-to-r bg-gradient-r-red flex-col text-center text-xl w-full max-w-btn-l py-4 text-white leading-9 rounded-lg mt-12 mb-4 cursor-pointer hover:opacity-75">
                    <a href={linkTarget(2)} id="click_target_try_target_2_pc">
                      {isMinkabuMember ? (
                        <div className="font-bold">資産目標サポートを試す</div>
                      ) : (
                        <>
                          <div className="flex justify-center mb-auto app-primary-label-block text-19">
                            <div className="inline-flex items-center flex-col">
                              初回30日間無料
                            </div>
                          </div>
                          <div className="font-bold">
                            みんかぶプレミアムで資産目標サポートを試す
                          </div>
                        </>
                      )}
                    </a>
                  </div>
                  <div className="leading-9 text-base flex justify-center items-center cursor-pointer underline">
                    <a
                      href={`${handlePremiumPage}?${commonParam}`}
                      target="_blank"
                      rel="noopener">
                      みんかぶプレミアムとは
                    </a>
                  </div>
                  {!isMinkabuMember && (
                    <div
                      className="mt-4 leading-9 text-base flex justify-center items-center cursor-pointer underline"
                      onClick={login}>
                      すでにみんかぶ会員の方はこちら
                    </div>
                  )}
                </div>
              </div>
              {/* SP */}
              <div className="flex lg:hidden flex-col container w-full pt-16 pb-16">
                <h2 className="text-2xl text-center font-bold mb-2 px-4 leading-10">
                  ライフイベントごとに
                  <br />
                  必要なお金を
                  <br />
                  AIアドバイスで貯められる
                </h2>
                <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2 px-4"></div>
                <div className="mt-8 px-4 text-base leading-8">
                  資産目標サポートでは、お金を貯める目的と目標金額から、
                  あなたにあった資産運用の達成をAIがアドバイスします。
                  <br />
                  「老後資金を貯めたい」「FIRE資金が欲しい」「教育費を準備したい」など
                  ライフイベントごとに必要なお金がきちんと貯められてるかがわかります！
                </div>
                <div className="flex items-end justify-center mt-8 px-4 mb-auto text-2xl">
                  <img src="/static/images/targetLP/line1.svg" alt="" />
                  <div className="inline-flex items-center flex-row mx-4 font-bold">
                    <h3 className="block">アセプラでできること</h3>
                  </div>
                  <img
                    src="/static/images/targetLP/line1.svg"
                    alt=""
                    style={{
                      transform: 'scale(-1, 1)',
                    }}
                  />
                </div>
                <SliderAreaSP />
                <div className="flex justify-center px-4 mt-10">
                  <img
                    src="/static/images/targetLP/report_notification.png"
                    alt="資産を管理、LINEに日々の資産情報を通知します"
                    className="w-full ml-6"
                  />
                </div>
                <div className="mt-4 px-4 text-lg font-bold text-center">
                  資産レポートで
                  <br />
                  運用状況をチェック！LINEも対応！
                </div>
                <div className="flex flex-col items-center mx-8">
                  <div className="bg-gradient-to-r bg-gradient-r-red flex flex-col text-center text-lg w-full max-w-btn-l py-2 mx-auto text-white rounded-lg my-8 cursor-pointer hover:opacity-75">
                    <a href={linkTarget(2)} id="click_target_try_target_2_sp">
                      {isMinkabuMember ? (
                        <div className="font-bold">資産目標サポートを試す</div>
                      ) : (
                        <>
                          <div className="flex justify-center mb-auto app-primary-label-block text-sm">
                            <div className="inline-flex justify-center flex-col">
                              初回30日間無料
                            </div>
                          </div>
                          <div className="font-bold leading-6">
                            みんかぶプレミアムで
                            <br />
                            資産目標サポートを試す
                          </div>
                        </>
                      )}
                    </a>
                  </div>
                  <div className="leading-9 text-base flex justify-center items-center cursor-pointer underline">
                    <a
                      href={`${handlePremiumPage}?${commonParam}`}
                      target="_blank"
                      rel="noopener">
                      みんかぶプレミアムとは
                    </a>
                  </div>
                  {!isMinkabuMember && (
                    <div
                      className="mt-4 leading-9 text-base flex justify-center items-center cursor-pointer underline"
                      onClick={login}>
                      すでにみんかぶ会員の方はこちら
                    </div>
                  )}
                </div>
              </div>
            </section>
            {/* 年代・金融商品別みんなのポートフォリオ */}
            <section className="bg-white js-ui-animation-fadeup">
              {/* PC */}
              <div className="hidden lg:flex flex-col text-center container pt-16 pb-16">
                <div className="flex items-end justify-center mb-auto text-3xl leading-8">
                  <img src="/static/images/targetLP/line2.svg" alt="" />
                  <div className="inline-flex items-end flex-row font-bold mx-4">
                    <span className="block">他の投資家はどうしてる？</span>
                  </div>
                  <img
                    src="/static/images/targetLP/line2.svg"
                    alt=""
                    style={{
                      transform: 'scale(-1, 1)',
                    }}
                  />
                </div>
                <h2 className="mt-8 mb-2 text-3xl font-bold leading-10">
                  年代・金融商品別
                  <br />
                  みんなのポートフォリオ
                </h2>
                <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2"></div>
                <h3 className="mt-10 mx-auto px-6 py-2 text-2xl font-bold text-white bg-gray-800 rounded-2xl">
                  資産形成の目的
                </h3>
                <div className="flex flex-row items-center justify-center mt-8">
                  <img
                    src="/static/images/targetLP/chart3.svg"
                    alt="資産形成目的別チャート"
                  />
                  <div className="px-4 py-3 ml-8 text-xl font-bold border-2 border-bluegray-700 rounded-2xl leading-7">
                    約70%の投資家が
                    <br />
                    「老後・病気・安心」に
                    <br />
                    備えて資産形成をはじめています
                  </div>
                </div>
                <h3 className="mt-10 mx-auto px-6 py-2 text-2xl font-bold text-white bg-gray-800 rounded-2xl">
                  年代別 金融商品を選ぶ基準
                </h3>
                <div className="flex flex-row items-center justify-center mt-8">
                  <div className="mx-8">
                    <img
                      src="/static/images/targetLP/chart4.svg"
                      alt="30代の投資傾向"
                    />
                  </div>
                  <div className="mx-8">
                    <img
                      src="/static/images/targetLP/chart5.svg"
                      alt="40代の投資傾向"
                    />
                  </div>
                  <div className="mx-8">
                    <img
                      src="/static/images/targetLP/chart6.svg"
                      alt="50代、60代、70代の投資傾向"
                    />
                  </div>
                </div>
                <div className="px-4 py-3 mx-auto mt-8 text-xl font-bold border-2 border-bluegray-700 rounded-2xl leading-7">
                  どの年代も、収益性・安全性に注目！
                  <br />
                  バランス重視の運用スタイルが◎
                </div>
                <h3 className="mt-16 mx-auto px-6 py-2 text-2xl font-bold text-white bg-gray-800 rounded-2xl">
                  年収別保有商品
                </h3>
                <div className="flex flex-row items-center justify-center mt-8">
                  <div className="mx-8">
                    <img
                      src="/static/images/targetLP/chart7.svg"
                      alt="年収300万円〜500万円資産形成の目的別チャート"
                    />
                  </div>
                  <div className="mx-8">
                    <img
                      src="/static/images/targetLP/chart8.svg"
                      alt="年収500万円〜750万円資産形成の目的別チャート"
                    />
                  </div>
                </div>
                <div className="px-4 py-3 mx-auto mt-8 text-xl font-bold border-2 border-bluegray-700 rounded-2xl leading-7">
                  年収が増えるにつれて、株式の資産が増えています
                </div>
                <div className="mt-12 text-xs font-bold text-bluegray-500">
                  参考サイト：
                  <a
                    href="https://www.shiruporuto.jp/public/document/container/yoron/futari2021-/2022/"
                    target="_blank"
                    rel="noopener">
                    <span className="underline">
                      金融広報中央委員会「知るぽると」
                    </span>
                  </a>
                </div>
              </div>
              {/* SP */}
              <div className="flex lg:hidden flex-col text-center container w-full px-4 pt-10 pb-16">
                <div className="flex items-end justify-center mb-auto text-2xl leading-8">
                  <img src="/static/images/targetLP/line2.svg" alt="" />
                  <div className="inline-flex items-center flex-row mx-4 font-bold">
                    <span className="block">
                      他の投資家は
                      <br />
                      どうしてる？
                    </span>
                  </div>
                  <img
                    src="/static/images/targetLP/line2.svg"
                    alt=""
                    style={{
                      transform: 'scale(-1, 1)',
                    }}
                  />
                </div>
                <h2 className="mt-8 mb-2 text-2xl font-bold leading-10">
                  年代・金融商品別
                  <br />
                  みんなのポートフォリオ
                </h2>
                <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2"></div>
                <h3 className="mt-8 mx-auto px-6 py-2 text-lg font-bold text-white bg-gray-800 rounded-2xl">
                  資産形成の目的
                </h3>
                <div className="flex justify-center mt-8 mx-2">
                  <img
                    src="/static/images/targetLP/chart3.svg"
                    alt="資産形成目的別チャート"
                  />
                </div>
                <div className="px-4 py-4 mt-6 mx-4 text-base font-bold border-2 border-black rounded-2xl">
                  約70%の投資家が
                  <br />
                  「老後・病気・安心」に
                  <br />
                  備えて資産形成をはじめています
                </div>
                <h3 className="mt-10 mx-auto px-6 py-2 text-lg font-bold text-white bg-gray-800 rounded-2xl">
                  年代別 金融商品を選ぶ基準
                </h3>
                <div className="flex justify-center mt-8 mx-4">
                  <img
                    src="/static/images/targetLP/chart4.svg"
                    alt="30代の投資傾向"
                  />
                </div>
                <div className="flex justify-center mt-8 mx-4">
                  <img
                    src="/static/images/targetLP/chart5.svg"
                    alt="40代の投資傾向"
                  />
                </div>
                <div className="flex justify-center mt-8 mx-4">
                  <img
                    src="/static/images/targetLP/chart6.svg"
                    alt="50代、60代、70代の投資傾向"
                  />
                </div>
                <div className="px-4 py-4 mt-6 mx-4 text-base font-bold border-2 border-black rounded-2xl">
                  どの年代も、収益性・安全性に注目！
                  <br />
                  バランス重視の運用スタイルが◎
                </div>
                <h3 className="mt-10 mx-auto px-6 py-2 text-lg font-bold text-white bg-gray-800 rounded-2xl">
                  年収別保有商品
                </h3>
                <div className="flex justify-center mt-8 mx-2">
                  <img
                    src="/static/images/targetLP/chart7.svg"
                    alt="年収300万円〜500万円資産形成の目的別チャート"
                  />
                </div>
                <div className="flex justify-center mt-4 mx-2">
                  <img
                    src="/static/images/targetLP/chart8.svg"
                    alt="年収500万円〜750万円資産形成の目的別チャート"
                  />
                </div>
                <div className="px-4 py-4 mt-6 mx-4 text-base font-bold border-2 border-black rounded-2xl">
                  年収が増えるにつれて、株式の資産が増えています
                </div>
                <div className="mt-12 text-xs font-bold text-bluegray-500">
                  参考サイト：
                  <a
                    href="https://www.shiruporuto.jp/public/document/container/yoron/futari2021-/2022/"
                    target="_blank"
                    rel="noopener">
                    <span className="underline">
                      金融広報中央委員会「知るぽると」
                    </span>
                  </a>
                </div>
              </div>
            </section>
            {/* 資産目標サポート活用例 */}
            <section className="bg-cyan-650">
              {/* PC */}
              <div className="hidden lg:flex flex-col text-center container w-full pt-16 pb-16">
                <h2 className="mb-8 text-3.5xl font-bold text-center text-white">
                  資産目標サポート活用例
                </h2>
                <ul className="w-full flex justify-center text-2xl leading-8">
                  <li
                    className="max-w-panel-m flex flex-col items-center py-6 px-4 text-base bg-white border border-solid rounded-lg"
                    style={{ height: '580px' }}>
                    <div className="flex flex-row items-center">
                      <div className="flex flex-col">
                        <div>
                          <img
                            src="/static/images/targetLP/person1.svg"
                            alt="30代の住宅資金の貯蔵額の調査"
                            className="mx-auto"
                            style={{ width: '66px', height: '66px' }}
                          />
                        </div>
                        <div className="text-sm leading-5">Aさん</div>
                      </div>
                      <div className="flex flex-col ml-2 items-start text-gray-800 leading-6">
                        <div className="text-lg font-bold leading-6">
                          住宅資金で500万円貯める
                        </div>
                        <div className="text-base">年齢：30歳</div>
                        <div className="text-base">年収：400万円</div>
                        <div className="text-base">投資経験：つみたてNISA</div>
                      </div>
                    </div>
                    <div className="mt-6">
                      <img
                        src="/static/images/targetLP/example1.png"
                        alt="月々の積立額をシミュレーションを表示"
                        className="mx-auto"
                        style={{ width: '250px', height: '330px' }}
                      />
                    </div>
                    <div className="text-base mt-4 leading-6">
                      毎月の積立額や運用期間から
                      <br />
                      目標達成に必要な
                      <span
                        className="text-lg font-bold"
                        style={{
                          backgroundImage:
                            'linear-gradient(to bottom, transparent 60%, rgb(255, 186, 7) 60%, rgb(255, 186, 7) 80%, transparent 80%)',
                        }}>
                        運用利回り
                      </span>
                      を計算！
                    </div>
                  </li>
                  <li
                    className="max-w-panel-m flex flex-col items-center py-6 px-4 ml-8 text-base bg-white border border-solid rounded-lg"
                    style={{ height: '580px' }}>
                    <div className="flex flex-row items-center">
                      <div className="flex flex-col">
                        <div>
                          <img
                            src="/static/images/targetLP/person2.svg"
                            alt="30代の資産別分布図"
                            className="mx-auto"
                            style={{ width: '66px', height: '66px' }}
                          />
                        </div>
                        <div className="text-sm leading-5">Bさん</div>
                      </div>
                      <div className="flex flex-col ml-2 items-start text-gray-800 leading-6">
                        <div className="text-lg font-bold leading-6">
                          教育資金で1500万円貯める
                        </div>
                        <div className="text-base">年齢：35歳</div>
                        <div className="text-base">年収：380万円</div>
                        <div className="text-base">
                          投資経験：投資信託、株式
                        </div>
                      </div>
                    </div>
                    <div className="mt-6">
                      <img
                        src="/static/images/targetLP/example2.png"
                        alt="どの資産を増やせばいいかを簡単アドバイス"
                        className="mx-auto"
                        style={{ width: '250px', height: '330px' }}
                      />
                    </div>
                    <div className="text-base mt-4 leading-6">
                      目標ポートフォリオと比べて、
                      <br />
                      <span
                        className="text-lg font-bold"
                        style={{
                          backgroundImage:
                            'linear-gradient(to bottom, transparent 60%, rgb(255, 186, 7) 60%, rgb(255, 186, 7) 80%, transparent 80%)',
                        }}>
                        どの資産を増やせばいいか
                      </span>
                      がわかる！
                    </div>
                  </li>
                  <li
                    className="max-w-panel-m flex flex-col items-center py-6 px-4 ml-8 text-base bg-white border border-solid rounded-lg"
                    style={{ height: '580px' }}>
                    <div className="flex flex-row items-center">
                      <div className="flex flex-col">
                        <div>
                          <img
                            src="/static/images/targetLP/person3.svg"
                            alt="40代が選ぶ投資商品と投資信託"
                            className="mx-auto"
                            style={{ width: '66px', height: '66px' }}
                          />
                        </div>
                        <div className="text-sm leading-5">Cさん</div>
                      </div>
                      <div className="flex flex-col ml-2 items-start text-gray-800 leading-6">
                        <div className="text-lg font-bold leading-6">
                          老後資金で2000万円貯める
                        </div>
                        <div className="text-base">年齢：40歳</div>
                        <div className="text-base">年収：500万円</div>
                        <div className="text-base">投資経験：株式、債券</div>
                      </div>
                    </div>
                    <div className="mt-6">
                      <img
                        src="/static/images/targetLP/example3.png"
                        alt="投資信託の商品の紹介"
                        className="mx-auto"
                        style={{ width: '250px', height: '330px' }}
                      />
                    </div>
                    <div className="text-base mt-4 leading-6">
                      <span
                        className="text-lg font-bold"
                        style={{
                          backgroundImage:
                            'linear-gradient(to bottom, transparent 60%, rgb(255, 186, 7) 60%, rgb(255, 186, 7) 80%, transparent 80%)',
                        }}>
                        低リスクの投資商品を
                      </span>
                      一覧で表示して
                      <br />
                      くれるから
                      <span
                        className="text-lg font-bold"
                        style={{
                          backgroundImage:
                            'linear-gradient(to bottom, transparent 60%, rgb(255, 186, 7) 60%, rgb(255, 186, 7) 80%, transparent 80%)',
                        }}>
                        銘柄が見つけやすい！
                      </span>
                    </div>
                  </li>
                </ul>
                <div className="flex flex-col items-center text-white">
                  <div className="flex bg-gradient-to-r bg-gradient-r-red flex-col text-center text-xl w-full max-w-btn-l py-4 text-white leading-9 rounded-lg mt-12 mb-4 cursor-pointer hover:opacity-75">
                    <a href={linkTarget(3)} id="click_target_try_target_3_pc">
                      {isMinkabuMember ? (
                        <div className="font-bold">資産目標サポートを試す</div>
                      ) : (
                        <>
                          <div className="flex justify-center mb-auto app-primary-label-block text-19">
                            <div className="inline-flex items-center flex-col">
                              初回30日間無料
                            </div>
                          </div>
                          <div className="font-bold">
                            みんかぶプレミアムで資産目標サポートを試す
                          </div>
                        </>
                      )}
                    </a>
                  </div>
                  <div className="leading-9 text-base flex justify-center items-center cursor-pointer underline">
                    <a
                      href={`${handlePremiumPage}?${commonParam}`}
                      target="_blank"
                      rel="noopener">
                      みんかぶプレミアムとは
                    </a>
                  </div>
                  {!isMinkabuMember && (
                    <div
                      className="mt-4 leading-9 text-base flex justify-center items-center cursor-pointer underline"
                      onClick={login}>
                      すでにみんかぶ会員の方はこちら
                    </div>
                  )}
                </div>
              </div>
              {/* SP */}
              <div className="flex lg:hidden flex-col text-center container w-full px-4 pt-14 pb-16">
                <h2 className="mb-4 text-2xl font-bold text-center text-white leading-10">
                  資産目標サポート活用例
                </h2>
                <ul className="w-full flex flex-col items-center justify-center text-2xl leading-8">
                  <li
                    className="max-w-panel-m flex flex-col items-center py-6 px-4 mb-4 text-base bg-white border border-solid rounded-lg"
                    style={{ height: '580px' }}>
                    <div className="flex flex-row items-center">
                      <div className="flex flex-col">
                        <div>
                          <img
                            src="/static/images/targetLP/person1.svg"
                            alt="30代の住宅資金の貯蔵額の調査"
                            className="mx-auto"
                            style={{ width: '66px', height: '66px' }}
                          />
                        </div>
                        <div className="text-sm leading-5">Aさん</div>
                      </div>
                      <div className="flex flex-col ml-2 items-start text-gray-800 leading-6">
                        <div className="text-lg font-bold leading-7">
                          住宅資金で500万円貯める
                        </div>
                        <div className="text-base">年齢：30歳</div>
                        <div className="text-base">年収：400万円</div>
                        <div className="text-base">投資経験：つみたてNISA</div>
                      </div>
                    </div>
                    <div className="mt-4">
                      <img
                        src="/static/images/targetLP/example1.png"
                        alt="月々の積立額をシミュレーションを表示"
                        className="w-full px-4"
                      />
                    </div>
                    <div className="text-base mt-2 leading-6">
                      毎月の積立額や運用期間から
                      <br />
                      目標達成に必要な
                      <span
                        className="text-lg font-bold leading-7"
                        style={{
                          backgroundImage:
                            'linear-gradient(to bottom, transparent 60%, rgb(255, 186, 7) 60%, rgb(255, 186, 7) 80%, transparent 80%)',
                        }}>
                        運用利回り
                      </span>
                      を計算！
                    </div>
                  </li>
                  <li
                    className="max-w-panel-m flex flex-col items-center py-6 px-4 mb-4 text-base bg-white border border-solid rounded-lg"
                    style={{ height: '580px' }}>
                    <div className="flex flex-row items-center">
                      <div className="flex flex-col">
                        <div>
                          <img
                            src="/static/images/targetLP/person2.svg"
                            alt="30代の資産別分布図"
                            className="mx-auto"
                            style={{ width: '66px', height: '66px' }}
                          />
                        </div>
                        <div className="text-sm leading-5">Bさん</div>
                      </div>
                      <div className="flex flex-col ml-2 items-start text-gray-800 leading-6">
                        <div className="text-lg font-bold leading-7">
                          教育資金で1500万円貯める
                        </div>
                        <div className="text-base">年齢：35歳</div>
                        <div className="text-base">年収：380万円</div>
                        <div className="text-base">
                          投資経験：投資信託、株式
                        </div>
                      </div>
                    </div>
                    <div className="mt-4">
                      <img
                        src="/static/images/targetLP/example2.png"
                        alt="どの資産を増やせばいいかを簡単アドバイス"
                        className="w-full px-4"
                      />
                    </div>
                    <div className="text-base mt-2 leading-6">
                      目標ポートフォリオと比べて、
                      <br />
                      <span
                        className="text-lg font-bold leading-7"
                        style={{
                          backgroundImage:
                            'linear-gradient(to bottom, transparent 60%, rgb(255, 186, 7) 60%, rgb(255, 186, 7) 80%, transparent 80%)',
                        }}>
                        どの資産を増やせばいいか
                      </span>
                      がわかる！
                    </div>
                  </li>
                  <li
                    className="max-w-panel-m flex flex-col items-center py-6 px-4 mb-4 text-base bg-white border border-solid rounded-lg"
                    style={{ height: '580px' }}>
                    <div className="flex flex-row items-center">
                      <div className="flex flex-col">
                        <div>
                          <img
                            src="/static/images/targetLP/person3.svg"
                            alt="40代が選ぶ投資商品と投資信託"
                            className="mx-auto"
                            style={{ width: '66px', height: '66px' }}
                          />
                        </div>
                        <div className="text-sm leading-5">Cさん</div>
                      </div>
                      <div className="flex flex-col ml-2 items-start text-gray-800 leading-6">
                        <div className="text-lg font-bold leading-7">
                          老後資金で2000万円貯める
                        </div>
                        <div className="text-base">年齢：40歳</div>
                        <div className="text-base">年収：500万円</div>
                        <div className="text-base">投資経験：株式、債券</div>
                      </div>
                    </div>
                    <div className="mt-4">
                      <img
                        src="/static/images/targetLP/example3.png"
                        alt="投資信託の商品の紹介"
                        className="w-full px-4"
                      />
                    </div>
                    <div className="text-base mt-2 leading-6">
                      <span
                        className="text-lg font-bold leading-7"
                        style={{
                          backgroundImage:
                            'linear-gradient(to bottom, transparent 60%, rgb(255, 186, 7) 60%, rgb(255, 186, 7) 80%, transparent 80%)',
                        }}>
                        低リスクの投資商品を
                      </span>
                      一覧で表示して
                      <br />
                      くれるから
                      <span
                        className="text-lg font-bold"
                        style={{
                          backgroundImage:
                            'linear-gradient(to bottom, transparent 60%, rgb(255, 186, 7) 60%, rgb(255, 186, 7) 80%, transparent 80%)',
                        }}>
                        銘柄が見つけやすい！
                      </span>
                    </div>
                  </li>
                </ul>
                <div className="flex flex-col items-center mx-4 text-white">
                  <div className="bg-gradient-to-r bg-gradient-r-red flex flex-col text-center text-lg w-full max-w-btn-l py-2 mx-auto text-white rounded-lg my-8 cursor-pointer hover:opacity-75">
                    <a href={linkTarget(3)} id="click_target_try_target_3_sp">
                      {isMinkabuMember ? (
                        <div className="font-bold">資産目標サポートを試す</div>
                      ) : (
                        <>
                          <div className="flex justify-center mb-auto app-primary-label-block text-sm">
                            <div className="inline-flex justify-center flex-col">
                              初回30日間無料
                            </div>
                          </div>
                          <div className="font-bold leading-6">
                            みんかぶプレミアムで
                            <br />
                            資産目標サポートを試す
                          </div>
                        </>
                      )}
                    </a>
                  </div>
                  <div className="leading-9 text-base flex justify-center items-center cursor-pointer underline">
                    <a
                      href={`${handlePremiumPage}?${commonParam}`}
                      target="_blank"
                      rel="noopener">
                      みんかぶプレミアムとは
                    </a>
                  </div>
                  {!isMinkabuMember && (
                    <div
                      className="mt-4 leading-9 text-base flex justify-center items-center cursor-pointer underline"
                      onClick={login}>
                      すでにみんかぶ会員の方はこちら
                    </div>
                  )}
                </div>
              </div>
            </section>
            {/* 他の資産管理アプリとの違い */}
            <section className="text-white bg-gray-800">
              {/* PC */}
              <div className="hidden lg:flex flex-col text-center container w-full pt-16 pb-16">
                <h2 className="mb-2 text-3xl font-bold leading-8">
                  他の資産管理アプリとの違い
                </h2>
                <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2"></div>
                <div className="w-full flex flex-row mt-12">
                  <div className="flex flex-col ml-4">
                    <img
                      src="/static/images/targetLP/features.png"
                      alt="ポートフォリオを管理して目標金額を達成しよう"
                      style={{ width: '430px', height: '480px' }}
                    />
                  </div>
                  <div
                    className="ml-12 mt-8 text-lg font-bold"
                    style={{ lineHeight: '2.875rem' }}>
                    <div className="flex items-center mt-12 leading-5">
                      <span className="mr-2 text-40 text-yellow-450">01</span>
                      目標から逆算し、必要利回りを算出
                    </div>
                    <div className="ml-4 flex items-center mt-12 leading-5">
                      <span className="mr-2 text-40 text-yellow-450">02</span>
                      リスクを抑えた銘柄をリストアップ
                    </div>
                    <div className="ml-8 flex items-center mt-12 leading-5">
                      <span className="mr-2 text-40 text-yellow-450">03</span>
                      LINE通知で忙しい投資家をサポート
                    </div>
                    <div className="ml-12 flex items-center mt-12 leading-5">
                      <span className="mr-2 text-40 text-yellow-450">04</span>
                      資産管理や取引履歴の分析もできる
                    </div>
                    <div className="ml-16 flex items-center mt-12 leading-5">
                      <span className="mr-2 text-40 text-yellow-450">05</span>
                      「国内最大級の金融メディア」ミンカブが運営
                    </div>
                  </div>
                </div>
                <div
                  className="relative mt-16"
                  style={{ marginLeft: '12rem', marginRight: '12rem' }}>
                  <div className="absolute" style={{ top: '-4%', left: '12%' }}>
                    <img
                      src="/static/images/targetLP/light.svg"
                      alt="資産管理のヒント"
                    />
                  </div>
                  <div className="mt-8 py-10 px-8 text-center border-2 border-white rounded-3xl">
                    <div className="text-2xl font-bold leading-8">
                      アセプラが無制限で使える！
                      <br />
                      「みんかぶプレミアム」の便利な機能を一部紹介
                    </div>
                    <div className="mt-4 text-lg text-left">
                      みんかぶプレミアムに加入すると、アセプラの「資産目標サポート」が使えるほか、「MINKABU（株式）」で独自条件で株式銘柄が探せる機能や、楽しんでお金の知識が身につく「みんかぶマガジン」もご利用いただけます。
                    </div>
                  </div>
                </div>
              </div>
              {/* SP */}
              <div className="flex lg:hidden flex-col text-center container w-full px-4 pt-10 pb-16">
                <h2 className="mt-8 mb-2 text-2xl font-bold leading-10">
                  他の資産管理アプリとの違い
                </h2>
                <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2"></div>
                <div className="flex flex-col mt-8 mx-auto">
                  <img
                    src="/static/images/targetLP/features.png"
                    alt="ポートフォリオを管理して目標金額を達成しよう"
                    className="w-full px-4"
                  />
                </div>
                <div className="flex items-center justify-center">
                  <div className="mt-4 text-base font-bold text-center leading-loose">
                    <div
                      className="flex items-center my-6"
                      style={{ lineHeight: '1.125rem' }}>
                      <span className="mr-2 text-3.5xl text-yellow-450 leading-9">
                        01
                      </span>
                      目標から逆算し、必要利回りを算出
                    </div>
                    <div
                      className="flex items-center my-6"
                      style={{ lineHeight: '1.125rem' }}>
                      <span className="mr-2 text-3.5xl text-yellow-450 leading-9">
                        02
                      </span>
                      リスクを抑えた銘柄をリストアップ
                    </div>
                    <div
                      className="flex items-center my-6"
                      style={{ lineHeight: '1.125rem' }}>
                      <span className="mr-2 text-3.5xl text-yellow-450 leading-9">
                        03
                      </span>
                      LINE通知で忙しい投資家をサポート
                    </div>
                    <div
                      className="flex items-center my-6"
                      style={{ lineHeight: '1.125rem' }}>
                      <span className="mr-2 text-3.5xl text-yellow-450 leading-9">
                        04
                      </span>
                      資産管理や取引履歴の分析もできる
                    </div>
                    <div
                      className="flex items-center text-left my-6"
                      style={{ lineHeight: '1.125rem' }}>
                      <span className="mr-2 text-3.5xl text-yellow-450 leading-9">
                        05
                      </span>
                      「国内最大級の金融メディア」ミンカブが運営
                    </div>
                  </div>
                </div>
                <div className="relative mt-8">
                  <div className="absolute" style={{ top: '-6%', left: '3%' }}>
                    <img
                      src="/static/images/targetLP/light.svg"
                      alt="資産管理のヒント"
                      style={{ width: '70px', height: '70px' }}
                    />
                  </div>
                  <div className="py-10 px-8 text-center border-2 border-white rounded-3xl leading-8">
                    <div className="text-lg font-bold">
                      アセプラが無制限で使える！
                      <br />
                      「みんかぶプレミアム」の便利な機能を一部紹介
                    </div>
                    <div className="mt-4 text-lg text-left">
                      みんかぶプレミアムに加入すると、アセプラの「資産目標サポート」が使えるほか、
                      <br />
                      「MINKABU（株式）」で独自条件で株式銘柄が探せる機能や、楽しんでお金の知識が身につく「みんかぶマガジン」もご利用いただけます。
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* 資産形成が一歩進む、お金の勉強 */}
            <section className="flex flex-col items-center px-2 lg:pt-16 pt-12 lg:pb-16 pb-12 lg:px-4 bg-white js-ui-animation-fadeup">
              <div className="lg:mb-8 mb-4">
                <h2
                  id="finance_study"
                  className="lg:text-3xl text-xl font-bold mb-2 leading-6">
                  資産形成が一歩進む、お金の勉強
                </h2>
                <div className="hidden lg:flex h-4 w-64 bg-red-500 right-half mx-auto"></div>
              </div>
              <div className="lg:px-4 lg:w-1/2 w-full h-72 min-h-full">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/uEplINbgSkQ"
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
              </div>
              {/* PC */}
              <div className="hidden lg:flex mt-8 text-2xl font-bold">
                『資産形成入門』将来のためのお金の作り方
              </div>
              {/* SP */}
              <div className="lg:hidden flex mt-8 text-base font-bold text-center">
                『資産形成入門』
                <br />
                将来のためのお金の作り方
              </div>
            </section>
            {/*メディア情報*/}
            <section className="container px-2 lg:py-16 py-12 lg:px-4">
              <div className="hidden lg:flex flex-col text-center mb-8">
                <h2
                  id="media"
                  className="lg:text-3xl text-xl font-bold mb-2 leading-6">
                  メディア情報
                </h2>
                <div className="h-4 w-64 bg-red-500 right-half mx-auto"></div>
              </div>
              {/* PC */}
              <div className="bg-white border rounded-lg shadow-panel py-10 px-24 lg:flex lg:flex-row hidden">
                <div className="w-1/2">
                  <div className="login-app flex items-center justify-center login-app-banner">
                    <div className="flex justify-center w-full">
                      <div className="flex flex-col justify-end max-w-375p">
                        <div className="flex items-end justify-between mb-auto app-primary-label-block">
                          <div className="inline-flex items-center flex-col text-bluegray-700 font-bold">
                            資産形成のお役立ち情報はこちらから
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row justify-center mt-4">
                    <a
                      href="https://twitter.com/minkabu_asepla"
                      target="_blank"
                      rel="noopener">
                      <img
                        src="/static/images/lp/x_icon.svg"
                        alt="x"
                        width="80"
                        height="80"
                      />
                    </a>
                  </div>
                </div>
                <div className="w-1/2 text-base">
                  <div className="text-lg font-bold">
                    アセプラ公式 X(Twitter)アカウント
                  </div>
                  <div className="mt-1 text-sm">
                    アセプラの活用方法やリリース情報をお知らせします。
                  </div>
                  <div className="mt-1 text-link">
                    <a
                      href="https://twitter.com/minkabu_asepla"
                      target="_blank"
                      rel="noopener">
                      <span className="underline">@minkabu_asepla</span>
                    </a>
                  </div>
                  <div className="mt-4 text-lg font-bold">
                    みんなの資産推移をチェック！
                  </div>
                  <div className="mt-1 text-link">
                    <a
                      href={`https://twitter.com/search?q=%23%E3%82%A2%E3%82%BB%E3%83%97%E3%83%A9&src=hashtag_click?${commonParam}`}
                      target="_blank"
                      rel="noopener">
                      <span className="underline">#アセプラ</span>
                    </a>
                  </div>
                </div>
              </div>
              {/* SP */}
              <div className="lg:hidden flex flex-col bg-white border rounded-lg shadow-panel py-6 px-4">
                <div className="text-xl font-bold text-center">
                  メディア情報
                </div>
                <div className="mt-4">
                  <div className="login-app flex items-center justify-center login-app-banner">
                    <div className="flex justify-center w-full">
                      <div className="flex flex-col justify-end max-w-375p">
                        <div className="flex items-end justify-between mb-auto app-primary-label-block">
                          <div className="inline-flex items-center flex-col text-bluegray-700 font-bold">
                            資産形成のお役立ち情報はこちらから
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row justify-center items-center mt-4">
                    <a
                      href="https://twitter.com/minkabu_asepla"
                      target="_blank"
                      rel="noopener">
                      <img
                        src="/static/images/lp/x_icon.svg"
                        alt="twitter"
                        width="80"
                        height="80"
                      />
                    </a>
                  </div>
                </div>
                <div className="mt-6 text-base">
                  <div className="text-xl font-bold text-center">
                    アセプラ公式 X(Twitter)アカウント
                  </div>
                  <div className="mt-1 text-sm mx-5">
                    アセプラの活用方法やリリース情報をお知らせします。
                  </div>
                  <div className="mt-1 text-link text-center">
                    <a
                      href="https://twitter.com/minkabu_asepla"
                      target="_blank"
                      rel="noopener">
                      <span className="underline">@minkabu_asepla</span>
                    </a>
                  </div>
                  <div className="mt-2 text-xl font-bold text-center">
                    みんなの資産推移をチェック！
                  </div>
                  <div className="mt-1 text-link text-center">
                    <a
                      href="https://twitter.com/search?q=%23%E3%82%A2%E3%82%BB%E3%83%97%E3%83%A9&src=hashtag_click"
                      target="_blank"
                      rel="noopener">
                      <span className="underline">#アセプラ</span>
                    </a>
                  </div>
                </div>
              </div>
            </section>
            {/* 資産形成を加速させるアプリ */}
            <section className="flex flex-col items-center py-16 px-4 text-white bg-cyan-600 js-ui-animation-fadeup">
              <h2>
                <img
                  src="/static/images/lp/home_img.png"
                  alt="株式投資のポートフォリオを管理するなら「みんかぶアセットプランナー」、「アセプラ」"
                  width="475"
                  height="340"
                />
              </h2>
              <div className="mt-4">
                <img
                  src="/static/images/lp/logo_minkabu_as_dark.svg"
                  alt="みんかぶアセットプランナー（アセプラ）"
                  width="315"
                  height="85"
                />
              </div>
              <div className="mt-1 text-sm font-bold">
                資産形成を加速させるアプリ
              </div>
              {/* PC */}
              <div className="hidden lg:flex flex-col text-center text-xl w-full max-w-btn-l py-4 text-white leading-9 border border-white rounded-lg mt-8 mb-4 cursor-pointer hover:opacity-75">
                <a
                  href={`${process.env.PUBLIC_URL}/`}
                  id="click_target_detail_asset_planner_1_pc">
                  <div className="font-bold">
                    アセットプランナーをもっと知りたい
                  </div>
                </a>
              </div>
              <div className="hidden bg-gradient-to-r bg-gradient-r-red lg:flex flex-col text-center text-xl w-full max-w-btn-l py-4 text-white leading-9 rounded-lg mt-4 mb-4 cursor-pointer hover:opacity-75">
                <a href={linkTarget(4)} id="click_target_try_target_4_pc">
                  {isMinkabuMember ? (
                    <div className="font-bold">アセプラを試す</div>
                  ) : (
                    <>
                      <div className="flex justify-center mb-auto app-primary-label-block text-19">
                        <div className="inline-flex items-center flex-col">
                          初回30日間無料
                        </div>
                      </div>
                      <div className="font-bold">
                        みんかぶプレミアムで資産目標サポートを試す
                      </div>
                    </>
                  )}
                </a>
              </div>
              {/* SP */}
              <div className="w-full px-4">
                <div className="lg:hidden flex flex-col text-center text-sm w-full max-w-btn-l py-2 mx-auto text-white border border-white rounded-lg my-8 cursor-pointer hover:opacity-75">
                  <a
                    href={`${process.env.PUBLIC_URL}/`}
                    id="click_target_detail_asset_planner_1_sp">
                    <div className="py-1 text-lg font-bold">
                      アセットプランナーを
                      <br />
                      もっと知りたい
                    </div>
                  </a>
                </div>
              </div>
              <div className="w-full px-4">
                <div className="lg:hidden bg-gradient-to-r bg-gradient-r-red flex flex-col text-center text-lg w-full max-w-btn-l py-2 mx-auto text-white rounded-lg mb-8 cursor-pointer hover:opacity-75">
                  <a href={linkTarget(4)} id="click_target_try_target_4_sp">
                    {isMinkabuMember ? (
                      <div className="font-bold">アセプラを試す</div>
                    ) : (
                      <>
                        <div className="flex justify-center mb-auto app-primary-label-block text-sm">
                          <div className="inline-flex justify-center flex-col">
                            初回30日間無料
                          </div>
                        </div>
                        <div className="font-bold leading-6">
                          みんかぶプレミアムで
                          <br />
                          資産目標サポートを試す
                        </div>
                      </>
                    )}
                  </a>
                </div>
              </div>
              <div className="leading-9 text-base flex justify-center items-center cursor-pointer underline">
                <a
                  href={`${handlePremiumPage}?${commonParam}`}
                  target="_blank"
                  rel="noopener">
                  みんかぶプレミアムとは
                </a>
              </div>
              {!isMinkabuMember && (
                <div
                  className="mt-4 leading-9 text-base flex justify-center items-center cursor-pointer underline"
                  onClick={login}>
                  すでにみんかぶ会員の方はこちら
                </div>
              )}
              <div className="flex flex-col justify-end max-w-375p mt-12">
                <div className="flex items-end justify-center lg:mb-auto app-primary-label-block">
                  <div className="inline-flex items-center flex-col lg:flex-row font-bold text-lg">
                    <span className="block">
                      アセプラのアプリを
                      <br />
                      無料でダウンロード
                    </span>
                  </div>
                </div>
                <ul className="flex justify-center items-center mt-1">
                  <li
                    className="cursor-pointer hover:opacity-75 active:opacity-75"
                    id="click_target_download">
                    <a
                      href="https://play.google.com/store/apps/details?id=jp.minkabu.ap"
                      target="_blank"
                      rel="noopener">
                      <img
                        src="/static/images/lp/google-play-badge.svg"
                        alt="badge"
                        width="300"
                        height="88.88"
                      />
                    </a>
                  </li>
                </ul>
                <div className="mt-1 mx-auto">
                  Apple Store Appは今後対応予定です
                </div>
              </div>
            </section>
            {/* 資産形成に役立つその他のおすすめ機能 */}
            <section className="flex flex-col items-center justify-center bg-neutral-150 lg:py-16 py-12 lg:px-64 px-4 font-bold">
              <div className="lg:text-3.5xl text-26 text-center">
                資産形成に役立つ
                <br />
                その他のおすすめ機能
              </div>
              <a href={linkSecuritiesAccountManagementLP}>
                {/* PC */}
                <div
                  className="lg:flex hidden w-full h-full flex-row mt-12 py-6 pl-8 pr-12 border-2 border-bluegray-700 bg-white rounded-lg hover:opacity-75"
                  id="click_target_account_namagement_pc"
                  style={{ maxWidth: '37rem', maxHeight: '18rem' }}>
                  <img
                    src="/static/images/targetLP/securities_account_management_link.png"
                    alt="複数の証券口座をどう資産管理してる？お悩み別おすすめ解決方法"
                    width="160"
                    height="138"
                  />
                  <div className="flex flex-col pl-12 items-center justify-center text-bluegray-700">
                    <div className="text-base">
                      あなたの資産のうごきが１分でわかる
                    </div>
                    <div className="mt-2 text-2xl text-center whitespace-no-wrap">
                      複数の証券口座を一括管理
                    </div>
                  </div>
                </div>
                {/* SP */}
                <div
                  className="lg:hidden flex w-full h-full flex-col items-center justify-center mt-8 pt-6 pb-4 px-8 border-2 border-bluegray-700 bg-white rounded-lg hover:opacity-75"
                  id="click_target_account_namagement_sp">
                  <img
                    src="/static/images/targetLP/securities_account_management_link.png"
                    alt="複数の証券口座をどう資産管理してる？お悩み別おすすめ解決方法"
                    width="127"
                    height="109"
                  />
                  <div className="flex flex-col items-center justify-center mt-4 text-bluegray-700">
                    <div className="text-sm">
                      あなたの資産のうごきが１分でわかる
                    </div>
                    <div className="mt-2 text-22 text-center">
                      複数の証券口座を一括管理
                    </div>
                  </div>
                </div>
              </a>
            </section>
            {/* よくある質問/参考情報 */}
            <section className="bg-white pt-16 pb-16 js-ui-animation-fadeup">
              <div className="container w-full px-2">
                <div className="text-center lg:mb-8">
                  <h2
                    id="faq"
                    className="lg:text-3xl text-xl font-bold mb-2 leading-6">
                    よくある質問/参考情報
                  </h2>
                  <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2"></div>
                </div>

                <div className="lg:px-4 px-2 py-4 leading-relax">
                  <dl>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          みんかぶアセットプランナー（アセプラ）とは何ですか？
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          みんかぶアセットプランナーとは、株式や投資信託を管理、分析する投資管理アプリです。複数の証券口座や銀行口座にある資産をまとめて管理できます。取引履歴や損益、資産推移などをチャートやグラフで確認できます。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          みんかぶアセットプランナー（アセプラ）でどんなことができますか？
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          みんかぶアセットプランナーでは以下の機能を提供しています。
                          <div className="mt-2 font-bold">
                            （1）資産管理チャート機能
                          </div>
                          <div>
                            複数の証券口座で保有する株式、投資信託などの資産をまとめて管理できます。損益、資産推移をチャートで確認できるほか、商品ごと、口座ごとにポートフォリオを見ることができます。複数口座の資産状況が一目でわかります。
                          </div>
                          <div className="mt-2 font-bold">
                            （2）資産のグルーピング機能
                          </div>
                          <div>
                            連携した証券口座や銀行口座などを「教育資金」「老後資金」など目的別、「NISA」「積立投資」など運用別にグループを分けて管理することができます。
                          </div>
                          <div className="mt-2 font-bold">
                            （3）取引履歴機能
                          </div>
                          <div>
                            株価チャート上に、株式や投資信託などの売買履歴を記録し、取引タイミングを振り返ることができます。過去の取引履歴から投資の傾向をつかみ、次回の取引に役立てることができます。
                          </div>
                          <div className="mt-2 font-bold">
                            （4）配当金管理機能
                          </div>
                          <div>
                            複数口座の配当金の入金額や予想配当金を銘柄ごとにまとめて管理できます。年間配当金、月別配当金がグラフで見れるほか、過去の入金実績も自動で集計します。税引き表示にも対応しています。利用者の声などは
                            <a
                              href="https://tw.minkabu.jp/postNotificationList/1768974239613"
                              className="text-link underline"
                              target="_blank"
                              rel="noopener">
                              「配当金を管理したい」にお答えします
                            </a>
                            をご参照ください。
                          </div>
                          <div className="mt-2 font-bold">
                            （5）資産目標サポート機能
                          </div>
                          <div>
                            「老後資金1,000万円」など資産運用の目的と目標金額を設定し、毎月の積立額や運用期間から目標達成までをシミュレーションできます。資産目標サポートでは、以下をご確認いただけます。
                            <br />
                            ・目標達成に必要な運用利回り
                            <br />
                            ・リスクを抑えた投資商品（投資信託・ETF）の提案
                            <br />
                            ・ポートフォリオ分析
                          </div>
                          <div className="mt-2 font-bold">
                            （6）資産レポート機能
                          </div>
                          <div>
                            保有資産の損益や資産変動などを日ごと、週ごと、月ごとにまとめて資産レポートを作成します。
                            <br />
                            資産レポートをLINEに送ることもできます。
                          </div>
                          <div className="mt-2 font-bold">
                            （7）ペルソナチャート機能
                          </div>
                          <div>
                            みんかぶアセットプランナーを利用しているユーザーの資産データを「年代」「年収」「投資歴」「投資先（株式、NISAなど）」「資産総額」などで絞り込み、自分の資産と比較できます。ペルソナチャート機能は、みんかぶ会員に登録すると無料でご利用いただけます。
                          </div>
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          連携できる証券会社はどこですか？
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          SBI証券、楽天証券をご連携いただけます。その他の証券会社は連携準備中となります（2025年8月時点）。
                          口座連携準備中の証券会社は、Moneytreeと連携することで一部の資産を管理できます。詳細は
                          <a
                            href="/#accountinfo"
                            className="text-link underline">
                            コチラ
                          </a>
                          をご確認ください。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          連携できる金融商品はなんですか？
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          以下の金融商品を連携することができます。
                          <br />
                          ・国内株式（現物、信用）
                          <br />
                          ・外国株式（現物）
                          <br />
                          ・投資信託
                          <br />
                          ・ETF・ETN（国内、外国）
                          <br />
                          ・REIT（国内、外国）
                          <br />
                          ・債券（国内、外国）
                          <br />
                          ・EB（国内、外国）
                          <br />
                          ・ロボアドバイザー
                          <br />
                          ・現金
                          <br />
                          連携できない資産（不動産、ゴールドなど）は、手入力で資産を追加し管理することができます。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        銀行口座も連携できますか？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          みんかぶアセットプランナーでは家計簿アプリ「マネーツリー」と連携し、銀行口座の「残高」や「取引/入出金履歴」を管理することができます。※
                          Moneytree IDと連携する必要があります。
                          <br />
                          詳しくは
                          <a
                            href="https://tw.minkabu.jp/postNotificationList/1768975113786"
                            className="text-link underline"
                            target="_blank"
                            rel="noopener">
                            「銀行口座を連携したい」にお答えします
                          </a>
                          をご参照下さい。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        おすすめの国内株式を提案する機能はありますか？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          みんかぶアセットプランナーには国内株式を提案する機能はありません。みんかぶの「株式ランキング」や「銘柄スクリーニング」などで銘柄を探すことができます。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          みんかぶアセットプランナーの利用料金を教えてください
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          SBI証券の口座をお持ちの方は一部の機能（複数口座連携、配当金管理、資産目標サポート、週次・月次レポートなど）を除き無料でご利用いただけます。
                          アセプラのすべての機能のご利用には「みんかぶプレミアム（税込1,320円/月）」にご登録が必要です。
                          <br />
                          初回登録のみ30日間無料でご利用いただけます。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          ポートフォリオとは何ですか？
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          ポートフォリオとは、保有資産がどの金融商品に配分されているかを表したグラフです。みんかぶアセットプランナーでは目標金額の達成に向けてポートフォリオを提案し、資産運用をサポートしています。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          ポートフォリオを管理するとどんなメリットがありますか？
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          ポートフォリオを管理することで、保有資産に偏りがないかを知ることが出来ます。投資先を集中させると暴落時に一度に多くの資産を失うリスクがあります。資産をバランス良く分散することで投資のリスクを最小限に抑えることができます。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          なぜ投資信託やETFを提案するのですか？
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          投資信託やETFは複数の資産に分散して投資するため、単一の投資先よりもリスクが低い傾向があります。みんかぶアセットプランナーでは、低リスク・長期の資産形成をサポートするため、投資信託やETFを提案しています。ただし、全ての投資にはリスクが伴いますので金融商品の選択はご自身の判断でお願いいたします。
                        </span>
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>
            </section>
            {/* 運営元・関連情報 */}
            <section className="flex pt-16 pb-16 bg-bluegray-50">
              <div className="container">
                <div className="text-center mb-8">
                  <h2
                    id="asepla_information"
                    className="lg:text-3xl text-xl font-bold mb-2 leading-6">
                    運営元・関連情報
                  </h2>
                  <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2"></div>
                </div>
                <table className="text-center w-full lg:w-1/2 lg:mx-auto">
                  <tbody>
                    <tr className="border-b border-gray-400 py-4">
                      <th className="px-2 py-4 font-bold bg-gray-300 w-1/4">
                        名称
                      </th>
                      <td className="px-2 py-4 bg-white w-3/4">
                        MINKABU ASSET PLANNER
                        <br />
                        （みんかぶアセットプランナー）
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4 font-bold bg-gray-300">
                        提供元
                      </td>
                      <td className="px-2 py-4 bg-white">
                        株式会社ミンカブ・ジ・インフォノイド
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4 font-bold bg-gray-300">
                        料金プラン
                      </td>
                      <td className="px-2 py-4 bg-white">
                        <p className="fonnt-bold">
                          月額1,320 円（税込）　※初回30日間無料
                        </p>
                        アセプラのご利用は基本有料となっております。
                        <br />
                        SBI証券口座連携のみ一部機能を無料でご利用いただけます。
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4 font-bold bg-gray-300">
                        利用環境
                      </td>
                      <td className="px-2 py-4 bg-white">
                        【Android】OS 9.0以上
                        <br />
                        【iPhone】iOS 13.0以上
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4 font-bold bg-gray-300">
                        注意事項
                      </td>
                      <td className="px-2 py-4 bg-white text-sm text-left">
                        ・MINKABU ASSET PLANNERは株式会社MONO
                        Investmentが提供するデータ収集システムおよび、マネーツリー株式会社が提供するMoneytree
                        LINK
                        APIを利用し、各証券会社や金融機関のWebサイトから情報を取得します。
                        <br />
                        ・SBI証券の「PC登録あんしんサービス」をご利用の口座はサービスをご利用いただけません。
                        証券会社Webサイトにて、ユーザーネームを変更された場合は、変更後の口座を新たに登録する必要があります。
                        変更後の口座は変更前の口座とは別の口座として扱われ、データは引き継がれません。
                        <br />
                        例 )<br />
                        資産推移画面で推移グラフが連続しない
                        <br />
                        取引詳細の「理由」欄が引き継がれない
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
            {userType !== 'premium' && (
              <>
                {/* PC */}
                <div className="lg:flex hidden">
                  <a
                    href={linkNewRegist}
                    className="block fixed z-40"
                    id="click_target_try_asset_planner_2_pc"
                    style={{ right: '10px', bottom: '10px' }}>
                    <img alt="" src="/static/images/lp/pc_cv_btn.svg" />
                  </a>
                </div>
                {/* SP */}
                <div className="flex lg:hidden">
                  <a
                    href={linkNewRegist}
                    className="block fixed w-full z-40 bg-white"
                    id="click_target_try_asset_planner_2_sp"
                    style={{ right: '0rem', bottom: '0rem' }}>
                    <div className="bg-gradient-to-r bg-gradient-r-red flex flex-row items-center justify-center text-center max-w-full py-3 m-1 rounded-lg cursor-pointer hover:opacity-75">
                      <div className="text-xl text-white font-bold">
                        いますぐ30日間無料体験を試す
                      </div>
                      <img
                        alt=""
                        src="/static/images/lp/icon_arrow_right.svg"
                        style={{ width: '19px', height: '19px' }}
                      />
                    </div>
                  </a>
                </div>
              </>
            )}
          </>
        )}

        {/* フッター */}
        <div id="footer" className="bg-gray-800 py-4 px-2 text-white text-sm">
          <div className="container">
            <ul className="text-center mt-2 mb-6">
              <li className="inline-block mr-4 underline">
                <a href="/">アセプラTOP</a>
              </li>
              <li className="inline-block mr-4">&gt;</li>
              <li className="inline-block">AIポートフォリオ管理</li>
            </ul>
            <ul className="text-center mb-8">
              <li className="inline-block mr-4">
                <a href="https://minkabu.co.jp/" target="_blank" rel="noopener">
                  運営会社
                </a>
              </li>
              <li className="inline-block mr-4">
                <a
                  href="https://info.minkabu.jp/tw_terms/"
                  target="_blank"
                  rel="noopener">
                  利用規約
                </a>
              </li>
              <li className="inline-block mr-4">
                <a
                  href="https://minkabu.co.jp/privacy_policy"
                  target="_blank"
                  rel="noopener">
                  プライバシーポリシー
                </a>
              </li>
              {!isIosApp() && (
                <>
                  <li className="inline-block mr-4">
                    <a
                      href="https://info.minkabu.jp/economy/"
                      target="_blank"
                      rel="noopener">
                      特定商取引表示
                    </a>
                  </li>
                  <li className="inline-block mr-4">
                    <a
                      href="https://info.minkabu.jp/law/"
                      target="_blank"
                      rel="noopener">
                      ご利用上の注意（関連法規）
                    </a>
                  </li>
                  <li className="inline-block mr-4">
                    <a
                      href="https://info.minkabu.jp/ad/"
                      target="_blank"
                      rel="noopener">
                      広告掲載・取扱商品
                    </a>
                  </li>
                  <li className="inline-block mr-4">
                    <a
                      href="https://support.minkabu.jp/hc/ja"
                      target="_blank"
                      rel="noopener">
                      ヘルプ/FAQ
                    </a>
                  </li>
                </>
              )}
            </ul>
            <div className="copyright lg:mb-4 mb-20">
              <a
                href="https://minkabu.co.jp/"
                className="text-center"
                title="株式会社ミンカブ・ジ・インフォノイドコーポレートサイトへ"
                target="_blank"
                rel="noopener">
                <img
                  loading="lazy"
                  src="/static/images/lp/min_infonoid_logo_white2.svg"
                  width="150"
                  height="25"
                  className="mx-auto"
                  alt="ミンカブ・ジ・インフォノイド ロゴ"
                />
              </a>
              <div className="text-center">
                <span className="dptblc tar vabt">
                  (C) MINKABU THE INFONOID, Inc.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
/* eslint-enable react/jsx-no-target-blank */

const SliderArea = () => {
  const sliderSettings: Settings = {
    dots: true,
    infinite: true,
    variableWidth: true,
    focusOnSelect: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    centerMode: true,
  };

  return (
    <div className="h-full pb-6">
      <div className="mx-auto py-2 px-16">
        <Slider {...sliderSettings} className="mt-4 targetlp_pc">
          <div>
            <div className="flex flex-col items-center justify-center">
              <img
                src="/static/images/targetLP/slider1.png"
                alt="目標管理ツールのチャート"
              />
              <div className="mt-2 text-2xl font-bold leading-7">
                カンタン目標設定
              </div>
            </div>
          </div>
          <div>
            <div className="flex flex-col items-center justify-center">
              <img
                src="/static/images/targetLP/slider2.png"
                alt="毎月の積立額を表示"
              />
              <div className="mt-2 text-2xl font-bold leading-7">
                必要利回りを
                <br />
                自動計算
              </div>
            </div>
          </div>
          <div>
            <div className="flex flex-col items-center justify-center">
              <img
                src="/static/images/targetLP/slider3.png"
                alt="投資商品のポートフォリオを組み替え比較"
              />
              <div className="mt-2 text-2xl font-bold leading-7">
                投資先の
                <br />
                ポートフォリを提案
              </div>
            </div>
          </div>
          <div>
            <div className="flex flex-col items-center justify-center">
              <img
                src="/static/images/targetLP/slider4.png"
                alt="条件にあったおすすめの銘柄を表示"
              />
              <div className="mt-2 text-2xl font-bold leading-7">銘柄探し</div>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};

const SliderAreaSP = () => {
  const sliderSettings: Settings = {
    dots: true,
    infinite: true,
    variableWidth: true,
    focusOnSelect: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: false,
    centerMode: true,
  };

  return (
    <div className="h-full pb-6">
      <div className="py-2">
        <Slider {...sliderSettings} className="mt-4 targetlp_sp">
          <div>
            <div className="flex flex-col items-center justify-center">
              <img
                src="/static/images/targetLP/slider1.png"
                alt="目標管理ツールのチャート"
              />
              <div className="mt-2 text-2xl font-bold leading-7">
                カンタン目標設定
              </div>
            </div>
          </div>
          <div>
            <div className="flex flex-col items-center justify-center">
              <img
                src="/static/images/targetLP/slider2.png"
                alt="毎月の積立額を表示"
              />
              <div className="mt-2 text-2xl font-bold text-center leading-7">
                必要利回りを
                <br />
                自動計算
              </div>
            </div>
          </div>
          <div>
            <div className="flex flex-col items-center justify-center">
              <img
                src="/static/images/targetLP/slider3.png"
                alt="投資商品のポートフォリオを組み替え比較"
              />
              <div className="mt-2 text-2xl font-bold text-center leading-7">
                投資先の
                <br />
                ポートフォリオを提案
              </div>
            </div>
          </div>
          <div>
            <div className="flex flex-col items-center justify-center">
              <img
                src="/static/images/targetLP/slider4.png"
                alt="条件にあったおすすめの銘柄を表示"
              />
              <div className="mt-2 text-2xl font-bold text-center leading-7">
                銘柄探し
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default TargetLP;
